export function safeExternalHttpUrl(value) {
  if (typeof value !== 'string' || !value.trim()) return null;
  try {
    const parsed = new URL(value.trim());
    if (!['http:', 'https:'].includes(parsed.protocol)) return null;
    if (parsed.username || parsed.password) return null;
    return parsed.href;
  } catch {
    return null;
  }
}

export function publicTransactionUrl(shareCode, origin = window.location.origin) {
  // Only the existing public invite code; never a dashboard URL or transaction ID.
  if (typeof shareCode !== 'string' || !/^(?:(?:TT|SD)-[A-Za-z0-9-]+|st-[A-Za-z0-9_-]{43})$/.test(shareCode)) return null;
  const base = new URL(origin);
  if (!['http:', 'https:'].includes(base.protocol)) return null;
  return `${base.origin}/t/${encodeURIComponent(shareCode)}`;
}

export async function copyTransactionUrl(url, browser = navigator, doc = document) {
  if (!url) throw new Error('Transaction link is unavailable');
  if (browser.clipboard?.writeText) {
    try { await browser.clipboard.writeText(url); return; } catch { /* Try the local selection fallback. */ }
  }
  const previousFocus = doc.activeElement;
  const field = doc.createElement('textarea');
  field.value = url;
  field.setAttribute('readonly', '');
  field.setAttribute('aria-label', 'Transaction link');
  field.style.cssText = 'position:fixed;left:0;top:0;opacity:0;';
  doc.body.appendChild(field);
  try {
    field.select();
    field.setSelectionRange(0, url.length);
    if (!doc.execCommand?.('copy')) throw new Error('Copy unavailable');
  } finally { field.remove(); previousFocus?.focus(); }
}

export function canShareTransaction(url, browser = navigator) {
  if (!url || typeof browser.share !== 'function') return false;
  try { return !browser.canShare || browser.canShare({ title: 'TrustTrade transaction', url }); } catch { return false; }
}

export async function shareTransactionUrl(url, browser = navigator, copy = copyTransactionUrl) {
  if (canShareTransaction(url, browser)) {
    try { await browser.share({ title: 'TrustTrade transaction', url }); return 'shared'; }
    catch (error) { if (error.name === 'AbortError') return 'cancelled'; }
  }
  await copy(url, browser);
  return 'copied';
}
